export default {"src":"/_next/static/image/public/images/flags/flag_850.a2601e0cd75a54f211c035a9e610cb18.svg","height":16,"width":24};